import React from "react";
import { Skeleton } from "@mui/material";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { useAuth } from "../../../context/AuthProvider";

const ViewServiceDoneByReport = ({
  isData,
  isLoading,
  isActive,
  onSaleView,
}) => {
  // console.log("Report Data:", isData);
  const { isUser } = useAuth();
  const reportData = isData?.reportData || [];
  return (
    <>
      <div className="table-responsive rtable">
        <table className="table table-sm table-bordered text-center">
          <tbody>
            <tr>
              <td className="fw-600">SERVICE DONE BY REPORT</td>
            </tr>
          </tbody>
        </table>

        <div className="d-flex rtable">
          <div className="w-50 ">
            <table className="table table-sm table-bordered">
              <tbody>
                <tr>
                  <td className="w-25">Name</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      isData?.reportInfo?.store?.title || ""
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="w-25">From Date</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : isData?.reportInfo?.fromdate ? (
                      DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          isData?.reportInfo?.fromdate,
                          isUser?.timezone,
                        ),
                      ).date
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="w-25">To Date</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : isData?.reportInfo?.todate ? (
                      DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          isData?.reportInfo?.todate,
                          isUser?.timezone,
                        ),
                      ).date
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="w-10"></div>

          <div className="w-50 rtable">
            {isData?.reportData?.length > 0 && (
              <table className="table table-sm table-bordered mb-0 text-center">
                <thead>
                  <tr>
                    <td colSpan="4">Overall Summary</td>
                  </tr>
                  <tr>
                    <td className="w-25 fw-500">Service Done By</td>
                    <td className="w-25 fw-500">Total Services</td>
                    <td className="w-25 fw-500">Amount</td>
                    <td className="w-25 fw-500">Tax</td>
                    <td className="w-25 fw-500">Total Amount</td>
                  </tr>
                </thead>

                <tbody>
                  {isData.reportData.map((item, index) => (
                    <tr key={index}>
                      <td>
                        {isLoading ? (
                          <Skeleton variant="text" />
                        ) : (
                          item.serviceDoneBy
                        )}
                      </td>

                      <td>
                        {isLoading ? (
                          <Skeleton variant="text" />
                        ) : (
                          item.summary?.totalServices || 0
                        )}
                      </td>

                      <td>
                        {isLoading ? (
                          <Skeleton variant="text" />
                        ) : (
                          `₹${CurrencyConverter.toCurrency(
                            item.summary?.totalBasePrice || 0,
                            "INR",
                          )}`
                        )}
                      </td>

                      <td>
                        {isLoading ? (
                          <Skeleton variant="text" />
                        ) : (
                          `₹${CurrencyConverter.toCurrency(
                            item.summary?.totalTaxAmount || 0,
                            "INR",
                          )}`
                        )}
                      </td>

                      <td>
                        {isLoading ? (
                          <Skeleton variant="text" />
                        ) : (
                          `₹${CurrencyConverter.toCurrency(
                            item.summary?.grandTotal || 0,
                            "INR",
                          )}`
                        )}
                      </td>
                    </tr>
                  ))}

                  {!isLoading && (
                    <tr className="fw-600 bg-light">
                      <td>Total</td>

                      <td>
                        {isData.reportData.reduce(
                          (sum, item) =>
                            sum + (item.summary?.totalServices || 0),
                          0,
                        )}
                      </td>

                      <td>
                        ₹
                        {CurrencyConverter.toCurrency(
                          isData.reportData.reduce(
                            (sum, item) =>
                              sum + (item.summary?.totalBasePrice || 0),
                            0,
                          ),
                          "INR",
                        )}
                      </td>

                      <td>
                        ₹
                        {CurrencyConverter.toCurrency(
                          isData.reportData.reduce(
                            (sum, item) =>
                              sum + (item.summary?.totalTaxAmount || 0),
                            0,
                          ),
                          "INR",
                        )}
                      </td>

                      <td>
                        ₹
                        {CurrencyConverter.toCurrency(
                          isData.reportData.reduce(
                            (sum, item) =>
                              sum + (item.summary?.grandTotal || 0),
                            0,
                          ),
                          "INR",
                        )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        </div>

        <table className="table table-sm table-bordered mb-3 mt-3 rtable">
          <thead>
            <tr>
              <th className="text-center">S No</th>
              <th className="text-center">Sale Mode</th>
              <th className="text-center">Sale No</th>
              <th className="text-center">Sale Date</th>
              <th className="text-center">Service Title</th>
              <th className="text-center">MRP</th>
              <th className="text-center">Discount</th>
              <th className="text-center">Amount</th>
              <th className="text-center">Tax</th>
              <th className="text-center">Qty</th>
              <th className="text-center">Total</th>
            </tr>
          </thead>

          <tbody>
            {reportData.map((serviceGroup, groupIndex) => (
              <React.Fragment key={groupIndex}>
                {/* Service Done By Heading */}
                <tr>
                  <td colSpan={11} className="fw-600 bg-light text-center">
                    {serviceGroup.serviceDoneBy}
                  </td>
                </tr>

                {/* Sales Rows */}
                {serviceGroup.sales.map((sale, index) => (
                  <tr
                    key={sale.saleId}
                    className="position-relative  cursor-poInter hover-row"
                    onClick={() => onSaleView(sale)}
                  >
                    <td className="text-center w-3">{index + 1}</td>
                    <td className="text-center w-5">{sale.saleMode}</td>
                    <td className="text-center w-8">{sale.saleNo}</td>
                    <td className="text-center w-10 ">
                      <span className="text-nowrap text-heading fw-medium">
                        {
                          DateConverter.ISOToDisplayFormat(
                            DateConverter.convertToTimeZone(
                              sale.saleDate,
                              isUser.timezone,
                            ),
                          ).date
                        }
                      </span>
                      {""},
                      <small>
                        {
                          DateConverter.ISOToDisplayFormat(
                            DateConverter.convertToTimeZone(
                              sale.saleDate,
                              isUser.timezone,
                            ),
                          ).time
                        }
                      </small>
                    </td>
                    <td className="text-center">{sale.serviceItem.title}</td>
                    <td className="text-center w-10">
                      ₹
                      {CurrencyConverter.toCurrency(
                        sale.serviceItem.lineTotalMrp || 0,
                        "INR",
                      )}
                    </td>
                    <td className="text-center w-10">
                      ₹
                      {CurrencyConverter.toCurrency(
                        sale.serviceItem.lineTotalDiscount || 0,
                        "INR",
                      )}
                    </td>
                    <td className="text-center w-10">
                      ₹
                      {CurrencyConverter.toCurrency(
                        sale.serviceItem.lineTotalBasePrice || 0,
                        "INR",
                      )}
                    </td>
                    <td className="text-center w-10">
                      ₹
                      {CurrencyConverter.toCurrency(
                        sale.serviceItem.lineTotalTaxAmount || 0,
                        "INR",
                      )}
                    </td>
                    <td className="text-center w-10 ">
                      {sale.serviceItem.quantity}{" "}
                      {sale.serviceItem?.unitConfig?.primaryUnitCode}
                    </td>

                    {/* <td className="text-center">
                      <span className="badge btn-unit">
                        {sale.serviceItem?.unitConfig?.primaryUnitCode || "-"}
                      </span>
                    </td> */}
                    <td className="text-center w-10">
                      ₹
                      {CurrencyConverter.toCurrency(
                        sale.serviceItem.lineGrandTotal || 0,
                        "INR",
                      )}
                    </td>
                  </tr>
                ))}

                <tr className="fw-600" style={{ backgroundColor: "#eaf6ea" }}>
                  <td colSpan={5} className="text-end">
                    Total
                  </td>
                  <td className="text-center">
                    ₹
                    {CurrencyConverter.toCurrency(
                      serviceGroup.summary?.totalMrp || 0,
                      "INR",
                    )}
                  </td>
                  <td className="text-center">
                    ₹
                    {CurrencyConverter.toCurrency(
                      serviceGroup.summary?.totalDiscount || 0,
                      "INR",
                    )}
                  </td>
                  <td className="text-center">
                    ₹
                    {CurrencyConverter.toCurrency(
                      serviceGroup.summary?.totalBasePrice || 0,
                      "INR",
                    )}
                  </td>
                  <td className="text-center">
                    ₹
                    {CurrencyConverter.toCurrency(
                      serviceGroup.summary?.totalTaxAmount || 0,
                      "INR",
                    )}
                  </td>
                  <td
                    className="text-center"
                    // style={{ backgroundColor: "#eaf6ea" }}
                  >
                    {/* Total Amount */}
                  </td>
                  <td
                    className="text-center"
                    style={{ backgroundColor: "#eaf6ea" }}
                  >
                    ₹
                    {CurrencyConverter.toCurrency(
                      serviceGroup.summary?.grandTotal || 0,
                      "INR",
                    )}
                  </td>
                </tr>
                {/* Total Row */}
                {/* <tr className="fw-600" style={{ backgroundColor: "#eaf6ea" }}>
                  <td colSpan={10} className="text-end">
                    Total Amount
                  </td>
                  <td className="text-center">
                    ₹
                    {CurrencyConverter.toCurrency(
                      serviceGroup.summary?.grandTotal || 0,
                      "INR",
                    )}
                  </td>
                </tr> */}
              </React.Fragment>
            ))}
          </tbody>
        </table>

        {/* Tax Overview (same for both) */}
        {/* <div className="d-flex rtable">
          <div className="w-50">
            {isData?.reportData?.length > 0 && (
              <table className="table table-sm table-bordered mb-0 rtable text-center">
                <thead>
                  <tr>
                    <td colSpan="4">Service Done By Summary</td>
                  </tr>
                  <tr>
                    <td>Service Done By</td>
                    <td>Total Services</td>
                    {/* <td>Total Qty</td> 
                    <td>Total Amount</td>
                  </tr>
                </thead>

                <tbody>
                  {isData.reportData.map((item, index) => (
                    <tr key={index}>
                      <td>
                        {isLoading ? (
                          <Skeleton variant="text" />
                        ) : (
                          item.serviceDoneBy
                        )}
                      </td>

                      <td>
                        {isLoading ? (
                          <Skeleton variant="text" />
                        ) : (
                          item.summary?.totalServices || 0
                        )}
                      </td>

                      {/* <td>
                        {isLoading ? (
                          <Skeleton variant="text" />
                        ) : (
                          item.summary?.totalQty || 0
                        )}
                      </td> 

                      <td>
                        {isLoading ? (
                          <Skeleton variant="text" />
                        ) : (
                          `₹${CurrencyConverter.toCurrency(
                            item.summary?.grandTotal || 0,
                            "INR",
                          )}`
                        )}
                      </td>
                    </tr>
                  ))}

                  {!isLoading && (
                    <tr className="fw-600 bg-light">
                      <td>Total</td>

                      <td>
                        {isData.reportData.reduce(
                          (sum, item) =>
                            sum + (item.summary?.totalServices || 0),
                          0,
                        )}
                      </td>

                      {/* <td>
                        {isData.reportData.reduce(
                          (sum, item) => sum + (item.summary?.totalQty || 0),
                          0,
                        )}
                      </td> 

                      <td>
                        ₹
                        {CurrencyConverter.toCurrency(
                          isData.reportData.reduce(
                            (sum, item) =>
                              sum + (item.summary?.grandTotal || 0),
                            0,
                          ),
                          "INR",
                        )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        </div> */}
      </div>
    </>
  );
};

export default ViewServiceDoneByReport;
